import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismButton } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import type { RecommendationStrategy } from 'lumen/models';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';
import { getNextSeasonalStrategyName } from 'lumen/utils/pricing-assistant/recommendation-settings';

interface SettingsRecommendationsCreateSeasonalStrategyButtonSignature {
  Args: {
    defaultStrategy?: RecommendationStrategy;
    isSomeStrategyCardBeingEdited?: boolean;
    seasonalStrategies: RecommendationStrategy[];
    setSomeStrategyCardBeingEditedState: (state: boolean) => void;
    settingsType: 'compset_positioning' | 'price_range';
  };
}

export default class SettingsRecommendationsCreateSeasonalStrategyButton extends Component<SettingsRecommendationsCreateSeasonalStrategyButtonSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithHotel;
  @service declare intl: Services['intl'];
  @service declare store: Services['store'];

  @action
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  onCreateSeasonalStrategyClicked() {
    if (this.args.defaultStrategy) {
      this.store.createRecord<RecommendationStrategy>(
        'recommendation-strategy',
        {
          seasonStartDt: null,
          seasonEndDt: null,
          conditions: null,
          conditionalStrategies: [],
          settings: this.args.defaultStrategy.settings,
          name: getNextSeasonalStrategyName(
            this.intl,
            this.args.seasonalStrategies,
          ),
          // @ts-expect-error: Type 'string | null' is not assignable to type 'number | undefined'.
          subscriptionId: this.hotelAndMarketService.hotel.id,
          settingsType: this.args.settingsType,
        },
      );

      this.args.setSomeStrategyCardBeingEditedState(true);
    }
  }

  <template>
    <PrismButton
      @buttonType="primary"
      @isDisabled={{@isSomeStrategyCardBeingEdited}}
      @label={{t "pricing_assistant.recommendations.create_seasonal_strategy"}}
      @onClick={{this.onCreateSeasonalStrategyClicked}}
      data-test-button
    />
  </template>
}
